import { useContext, useEffect } from "react";
import { UserContext, UserPayload } from "../Context/userContext";
import { useNavigate } from "react-router-dom";
import authService from "../utils/authService";
import { AuthStatusEnum } from "../constants/authConstants";

export const usePostAuthRedirect = () => {
    const { authStatus, setPendingRedirect } = useContext(UserContext) as UserPayload;
    const navigate = useNavigate();

    useEffect(() => {
        if(authStatus !== AuthStatusEnum.AUTHENTICATED) return;
        const returnTo = authService.consumeReturnTo();
        setPendingRedirect(false);
        if(returnTo) {
            navigate(returnTo, { replace: true });
        }
    },[authStatus, navigate]);
}